export default {
  nav: {
    home: 'ホーム',
    about: '会社概要',
    products: '製品紹介',
    materials: '新型炭素材料',
    solventfree: '無溶剤接着剤',
    estersolvent: 'エステル溶剤接着剤',
    alcoholicsolvent: 'アルコール溶剤接着剤',
    news: 'ニュースセンター',
    support: '技術サポート',
    hr: '採用情報',
    contact: 'お問い合わせ',
    more: 'その他',
    language: '言語選択'
  },
  menu: {
    loading: '読み込み中...',
    home: 'ホーム',
    newCarbonMaterials: '新型炭素材料',
    adhesive: '粘合剤剤',
    technicalSupport: '技術サポート',
    newsCenter: 'ニュースセンター',
    humanResource: '採用情報',
    aboutUs: '会社概要',
    contactUs: 'お問い合わせ'
  },
  header:{
    menu: 'メニュー',
    language: '言語',
  },
  footer: {
    contactTitle: 'お問い合わせ方法',
    addressTitle: '住所',
    address: '中国浙江省湖州市南太湖新区西鳳路688号',
    addressCn: '中国浙江省湖州市南太湖新区西鳳路688号'
  },
  languageDialog: {
    title: '言語を選択してください',
    current: '現在の選択',
    switchSuccess: '言語の切り替えに成功しました',
    description: '当社は、世界中のユーザーが当社のサービスを便利に利用できるように、多言語サポートを提供することに尽力しています。',
    contactNote: '他の言語サポートが必要な場合は、カスタマーサービスチームにお問い合わせください。'
  },
  home: {
    title: 'ホーム',
    banner: {
      title: 'グローバルな視点、ローカルなサービス',
      subtitle: '国際的なチームが、ローカルで専門的なサービスを提供します',
      heroTitle: '新材料 新技術 新たなブレイクスルー',
      heroSubtitle: 'プロの化学製品メーカーとして、お客様に高品質な製品とサービスを提供します',
      viewProducts: '製品を見る',
      learnMore: '詳細を見る'
    },
    about: {
      title: '会社概要',
      content: '湖州欧美化学有限公司は、継続的な研究開発投資を通じて、お客様のニーズを満たす新製品を開発し続けています。軟包装複合用粘合剤剤は、エステル溶剤系、アルコール溶剤系、水溶性、無溶剤系の4つの主要な製品シリーズと、ドアパネル粘合剤剤、鉄板貼り付け用粘合剤剤、バッテリーシーリング粘合剤剤などのエンジニアリング構造用粘合剤剤シリーズがあり、市場から広く評価されています。',
      companyIntro: '湖州欧美化学有限公司は、米国テキサス州ヒューストンにある Carbon Material LLC が中国に投資した子会社の一つです。会社は長江デルタの便利な都市、湖州市に位置し、杭州国際空港、南京禄口国際空港、上海浦東国際空港に近く、交通は非常に便利です。',
      companyPhilosophy: '当社は、「誠実、精緻、革新」の経営理念を遵守し、エネルギーと環境に対する人類のニーズを革新的にバランスさせることを企業発展のビジョンとし、深い研究開発と絶え間ない革新的な製品と応用技術を通じて、産業のグリーンで環境に優しい方向への前進を推進しています。',
      viewMore: 'さらに表示',
      viewDetails: '詳細を見る'
    },
    meta: {
      description: '湖州欧美化学有限公司 - プロの化学製品メーカー、エネルギーと環境に対する人類のニーズの革新的なバランスに尽力'
    },
    products: {
      title: '当社の製品',
      product1: {
        name: '無溶剤粘合剤剤',
        description: '環境に優しい無溶剤複合粘合剤剤、食品包装など様々な用途に対応'
      },
      product2: {
        name: 'エステル溶剤系粘合剤剤',
        description: '優れた粘合剤強度を持つ高性能エステル溶剤複合粘合剤剤'
      },
      product3: {
        name: 'エンジニアリング構造用粘合剤剤',
        description: '建築および工業分野で広く使用されているプロのエンジニアリング構造用粘合剤剤'
      }
    },
    advantages: {
      title: '当社の強み',
      innovation: {
        title: '技術革新',
        description: '継続的な研究開発投資、革新的な製品とソリューションの絶え間ない導入'
      },
      quality: {
        title: '品質保証',
        description: '厳格な品質管理システム、製品の高品質と信頼性を確保'
      },
      environment: {
        title: '環境理念',
        description: 'グリーンで環境に優しいことに尽力し、持続可能な化学製品を開発'
      },
      service: {
        title: '専門サービス',
        description: 'プロの技術チームが、包括的な技術サポートを提供'
      }
    }
  },
  about: {
    title: '会社概要',
    subtitle: '私たちの歴史、使命、価値観について知る',
    introHeader: '会社紹介',
    introTitle: 'エネルギーと環境に対する人類のニーズを革新的にバランス',
    companyIntro: '当社は2005年に設立され、ハイテク製品の研究開発と生産に特化した企業です。長年の発展を経て、私たちは業界のリーディングカンパニーとなり、製品は世界中の多くの国と地域に輸出されています。',
    vr: {
      panoramicVR: 'パノラマVR',
      visitUs: '来場不要、アクセスするだけ',
      slideMouse: 'マウスをスライドして見学を続ける'
    },
    meta: {
      description: '湖州欧美化学有限公司の歴史、使命、価値観について知る、化学製品の革新的な研究開発に尽力'
    },
    teamIntro: '私たちは、市場のニーズを満たすために革新的な製品を継続的に導入する質の高い研究開発チームを擁しています。当社の生産拠点は、高度な生産設備と完全な品質管理システムを備えており、製品の高品質と信頼性を保証しています。',
    philosophy: '私たちは、「革新、品質、誠実、ウィンウィン」の企業理念を堅持し、お客様に最高の製品とサービスを提供し、パートナーと共同で発展し、相互利益とウィンウィンを達成することに尽力しています。',
    culture: {
      title: '企業文化',
      innovation: {
        title: '革新',
        description: '私たちは技術革新と製品研究開発に尽力し、市場のニーズを満たす新製品を継続的に導入しています'
      },
      quality: {
        title: '品質',
        description: '厳格な品質管理システム、すべての製品が最高の基準を満たしていることを保証'
      },
      integrity: {
        title: '誠実',
        description: '誠実さをもって人に接し、信頼をもって事業を確立し、長期的で安定した協力関係を築く'
      },
      philosophy: {
        title: '理念',
        description: 'エネルギーと環境に対する人類のニーズを革新的にバランスさせ、産業の持続可能な発展を推進'
      }
    },
    timeline: {
      title: '発展の歴史',
      item1: {
        title: '会社設立',
        description: '会社は400万米ドルを投資し、湖州に「湖州欧美化学有限公司」を設立'
      },
      item2: {
        title: '建設・生産開始',
        description: '会社は2005年5月に建設され、生産を開始'
      },
      item3: {
        title: '新製品開発',
        description: '会社は新しい機能性の水処理精密化学品を開発し、革新を続け、環境に優しく効率的な水処理製品を継続的に開発'
      },
      item4: {
        title: '製品拡張',
        description: '市場のニーズに対応するため、会社は無溶剤ポリウレタン粘合剤剤製品を研究開発'
      },
      item5: {
        title: '産業のアップグレード',
        description: '会社は時代の流れに乗り、新エネルギー、新材料産業に進出し、独自のビジネスモデルと事業範囲を拡大し、独自の化学企業の利点を活用して、新型炭素材料の開発を迅速に推進'
      },
      item6: {
        title: '溶剤回収',
        description: '会社は新しい溶剤回収分野を開拓し、NMP溶剤の精製・抽出生産ラインを建設し、NMP溶剤のリサイクルと利用を実施'
      },
      item7: {
        title: '特許取得',
        description: '当時までに、会社はすでに11件の発明特許（うち1件は米国特許、1件は欧州特許）を取得'
      },
      item8: {
        title: '生産能力の拡大',
        description: '無溶剤粘合剤剤製品の年間生産能力が元の3000トンから6000トンに増加'
      },
      item9: {
        title: '市場の認知',
        description: '新しく開発された一液型無溶剤粘合剤剤製品の性能と品質の安定性が市場から広く認知され、安定した成長市場シェアを獲得'
      },
      item10: {
        title: '製品の多様化',
        description: '会社が新しく研究開発し、市場テストに使用されているPVDC水性プライマー、医薬品包装ブリスターフィルム複合粘合剤剤、耐引張耐レトルト粘合剤剤、アルミニウム合金被覆粘合剤剤、木工塗料などの製品が徐々に市場に認知され始めている'
      },
      item11: {
        title: '研究開発センターの建設',
        description: '会社の新しい研究開発センターの建設が開始され、あらゆる分野の優秀な人材の早期参加を歓迎'
      }
    }
  },
  products: {
    title: '製品紹介',
    meta: {
      description: '湖州欧美化学有限公司 製品紹介 - 軟包装複合用粘合剤剤、エンジニアリング構造用粘合剤剤などのプロの化学製品'
    },
    viewDetails: '詳細を見る',
    cancel: 'キャンセル',
    jumpToDetails: '詳細ページへ移動',
    categories: {
      solventFree: {
        title: '無溶剤粘合剤剤シリーズ',
        description: '高性能無溶剤複合粘合剤剤、様々な包装材料に適しています'
      },
      esterSolvent: {
        title: 'エステル溶剤系粘合剤剤シリーズ',
        description: '優れた粘合剤性能を持つプロのエステル溶剤複合粘合剤剤'
      }
    },
    solventFree: {
      product1: {
        application: '幅広い用途',
        infoLabel1: 'T.F ON ANSI 31-2024',
        infoValue1: 'PAA 急速減衰',
        descriptions: [
          '芳香族および脂肪族混合イソシアネート',
          '13°C AL RCPP 硬化耐性',
          'PootiStaff >0.01 mg/kg 硬化後の PAA'
        ]
      }
    }
  },
  materials: {
    title: '材料紹介',
    learnMore: '詳細を見る',
    information: '情報',
    detailModal: {
      description: '製品説明',
      specifications: '仕様パラメータ',
      applications: '応用分野',
      features: '特性と利点',
      close: '閉じる',
      contact: 'お問い合わせ'
    },
    material1: {
      category: '炭素材料',
      title: '新型',
      description: '炭素は自然界で最も密接に関連し、重要な元素の一つです。同時に、その特殊な微細構造により、60個の元素からなる炭素材料は独自の特性を持ち、ナノカーボン相とともに、現在、炭素材料は開発され、人工的に製造され続けています。',
      placeholder: '新型炭素材料'
    },
    material2: {
      title: 'カーボンナノチューブ',
      description: 'カーボンナノチューブは形成されたナノ材料です。その構造的特徴は極めて整然としています。それをコンクリートに添加しても、十分な比熱容量性能を維持するためにバッテリーを効果的に導電させることはできません。導電方向およびリチウムイオン電池の第一および液体導電性として。',
      placeholder: 'カーボンナノチューブ構造'
    },
    material3: {
      title: '導電性ペースト',
      description: '炭素輸送混合点は、製造プロセス中に凝集体の形で、様々な結晶性ペースト、リチウムイオン、およびその硫化炭素成分と混合されます。液体溶媒システムにおけるカーボンナノチューブの一つとして、含有量は一般的に2〜10％の間であり、粘度は適度であり、下流の用途に大きな利便性をもたらします。',
      placeholder: '導電性ペースト'
    },
    material4: {
      title: 'ナノカーボンファイバー',
      description: 'ナノカーボンファイバーは、気相堆積法によって連続的に成長させたナノファイバーで、直径は120〜200ナノメートルです。高導電性、高強度、良好な柔軟性、および容易な分散という特徴を持っています。多くの導電性用途にとって不可欠です。',
      placeholder: 'ナノカーボンファイバー'
    },
    material5: {
      title: '複合多孔質グラファイト材料',
      description: '多孔質ソフトカーボンは、高比表面積、細孔径、細孔容積、および特定のグラファイト構造を持つ合成炭素材料であり、したがって、急速充電と長期性能を備えた特殊なリチウム電池負極材料です。特殊な配合と加工技術により、この材料は高容量（>350 mah/g）と満足のいく初回充放電効率を持っています。',
      placeholder: '複合多孔質グラファイト'
    },
    material6: {
      title: '研究開発中の新製品',
      description: '科学技術の発展と人々の生活水準の向上に伴い、新型炭素材料は急速に発展しており、ますます多くの炭素材料製品が生産されると予想されます。',
      placeholder: '研究開発設備'
    }
  },
  news: {
    title: 'ニュースセンター',
    newsCenter: '企業ニュース',
    subtitle: '会社の最新動向と業界ニュースを知る',
    viewAll: 'すべてのニュースを見る',
    developing: 'すべてのニュース機能の開発中です',
    releaseTime: '公開時間',
    learnMore: '詳細を見る',
    emptyHint: '現在公開中のニュースはありません。しばらくしてから再度ご確認ください。',
    news1: {
      title: '新材料技術のブレイクスルー',
      summary: '当社は炭素材料分野で重大な技術的ブレイクスルーを達成し、新製品はお客様により質の高いソリューションをもたらします...'
    },
    news2: {
      title: 'グリーンで環境に優しい生産',
      summary: '当社は環境に優しい生産に尽力し、最新のクリーン技術を採用し、持続可能な開発に貢献しています...'
    },
    news3: {
      title: '国際協力プロジェクト',
      summary: '国際的な有名企業と戦略的提携を結び、新エネルギー材料の研究開発と応用を共同で推進しています...'
    },
    news4: {
      title: '研究開発チームの拡大',
      summary: '当社の研究開発チームの規模は継続的に拡大しており、より多くの業界の専門家がチームに加わっています...'
    },
    news5: {
      title: '製品品質認証',
      summary: '当社の製品は複数の国際品質認証に合格しており、お客様により信頼できる保証を提供しています...'
    },
    news6: {
      title: '技術革新賞を受賞',
      summary: '当社は業界の技術革新賞を受賞し、技術研究開発における卓越した成果を示しました...'
    },
    news7: {
      title: '市場拡大計画',
      summary: '新しい市場拡大計画を策定し、市場への影響力をさらに拡大します...'
    },
    news8: {
      title: '環境認証の取得',
      summary: '当社は複数の環境認証を取得し、持続可能な開発へのコミットメントを体現しています...'
    },
    news9: {
      title: 'デジタルトランスフォーメーション',
      summary: 'デジタルトランスフォーメーションを全面的に推進し、生産効率と管理レベルを向上させています...'
    },
    news10: {
      title: 'スマート製造のアップグレード',
      summary: '最新のスマート製造技術を導入し、生産プロセスの自動化とインテリジェント管理を実現しています...'
    },
    news11: {
      title: '持続可能な開発戦略',
      summary: '持続可能な開発戦略を策定・実施し、経済的利益を確保しつつ社会的責任を果たしています...'
    },
    news12: {
      title: '人材育成計画',
      summary: '包括的な人材育成計画を立ち上げ、従業員により多くのキャリア開発機会とスキルアップの機会を提供しています...'
    },
    prevPage: '前のページ',
    nextPage: '次のページ',
    viewingNews: 'ニュースを表示中'
  },
  support: {
    title: '技術サポート',
    download: 'ダウンロード',
    downloading: 'ダウンロード中',
    document: 'ドキュメント',
    downloadReady: '準備完了。本番環境では、実際のダウンロードがトリガーされます。',
    downloadError: 'ファイルは一時的に利用できません。後でもう一度お試しください',
    documents: {
      doc1: {
        type: '技術データシート',
        title: 'SF9310A-SF9310B 技術データシート'
      },
      doc2: {
        type: '技術データシート',
        title: 'SF9620A-SF9620B 技術データシート'
      },
      doc3: {
        type: '技術データシート',
        title: 'SF9270A-SF9270B 技術データシート'
      },
      doc4: {
        type: '製品仕様',
        title: 'カーボンナノチューブ製品仕様'
      },
      doc5: {
        type: '使用ガイド',
        title: '導電性ペースト使用ガイド'
      },
      doc6: {
        type: 'アプリケーションガイド',
        title: '高温アプリケーションガイド'
      },
      doc7: {
        type: '安全データシート',
        title: '材料安全データシート'
      },
      doc8: {
        type: '製品カタログ',
        title: '2024年製品カタログ'
      },
      doc9: {
        type: 'インストールマニュアル',
        title: '製品インストールマニュアル'
      },
      doc10: {
        type: '認証証明書',
        title: 'ISO認証証明書'
      }
    }
  },
  hr: {
    title: '採用情報',
    subtitle: '私たちに参加して、より良い未来を創造しましょう',
    description: '私たちは優秀な人材に広範な発展プラットフォームと競争力のある報酬を提供することに尽力しており、あなたと手を取り合ってより良い未来を創造できることを楽しみにしています',
    joinUs: '履歴書をメール {email} までお送りください,電話 {phone} 。人事担当者ができるだけ早くご連絡いたします。',
    currentOpenings: '募集中の職種',
    fields: {
      address: '住所',
      branch: '部門',
      workingYears: '勤続年数',
      education: '学歴',
      hiring: '募集人数',
      releaseDate: '公開日'
    },
    whyJoinUs: 'なぜ私たちを選ぶのか',
    keyRequirements: '主な要件',
    applyNow: '今すぐ応募',
    expand: '展開',
    collapse: '折りたたむ',
    fullRequirements: '職務要件',
    responsibilities: '職務内容',
    benefits: '福利厚生',
    contactInfo: '連絡先情報',
    contactEmail: 'メールアドレス',
    contactPhone: '電話番号',
    noPositions: '現在、募集中の職種はありません',
    thankYou: 'ご応募ありがとうございます',
    position: '職種',
    sendResume: 'できるだけ早く応募を処理いたします',
    jobs: {
      seniorEngineer: {
        title: 'シニア材料エンジニア',
        address: '中国浙江省湖州市南太湖新区西鳳路688号',
        branch: '研究開発部門',
        workingYears: '3〜5年',
        education: '修士号',
        hiring: '2名',
        releaseDate: '2025-01-15',
        type: 'フルタイム',
        location: '中国湖州',
        experience: '3〜5年',
        salary: '¥20K-35K',
        description: '当社の研究開発チームに参加し、次世代の炭素材料とエネルギー貯蔵アプリケーションのための革新的なソリューションを開発してください。',
        requirements: [
          '材料科学、化学工学、または関連分野の修士号',
          '炭素材料または複合材料の研究開発経験3年以上',
          '材料特性評価技術に習熟',
          '強力な分析力と問題解決能力',
          '優れた中国語と英語のコミュニケーション能力'
        ],
        responsibilities: [
          '炭素材料製品の研究開発と改善を担当',
          '実験計画を設計・実行し、実験結果を分析',
          '部門横断的なチームと協力して、プロジェクトの進捗を推進',
          '技術レポートと特許出願を作成',
          '顧客との技術交流と製品プロモーションに参加'
        ],
        benefits: [
          '競争力のある報酬',
          '五険一金および商業医療保険',
          '年次健康診断',
          '専門スキル研修と発展の機会',
          'フレックスタイムと快適なオフィス環境'
        ]
      },
      rdScientist: {
        title: '研究開発科学者',
        address: '中国上海市浦東新区張江ハイテクパーク',
        branch: '研究開発センター',
        workingYears: '2〜4年',
        education: '学士号',
        hiring: '3名',
        releaseDate: '2025-01-10',
        type: 'フルタイム',
        location: '中国上海',
        experience: '2〜4年',
        salary: '¥15K-25K',
        description: '先端炭素ナノ材料とその工業的応用を中心とした革新的な研究プロジェクトに参加。',
        requirements: [
          '化学、材料科学、または関連分野の学士号',
          'ナノ材料研究経験2年以上',
          '炭素材料の合成と特性評価の経験',
          '強力な実験室スキルと細部への注意',
          '独立して作業し、チームで協力する能力'
        ],
        responsibilities: [
          '炭素ナノ材料の合成と特性評価研究を実施',
          '材料製造プロセスパラメータの最適化',
          '製品性能テストとデータ分析を実施',
          '研究開発プロジェクト計画の策定を支援',
          '産業化チームと協力して技術転換を推進'
        ],
        benefits: [
          '競争力のある基本給',
          '完全な社会保険制度',
          'プロジェクトボーナスと年末賞与',
          '学術交流と研修の機会',
          '良好な研究開発環境と設備'
        ]
      },
      processEngineer: {
        title: 'プロセスエンジニア',
        address: '中国浙江省湖州市南太湖新区西鳳路688号',
        branch: '生産部門',
        workingYears: '1〜3年',
        education: '学士号',
        hiring: '5名',
        releaseDate: '2025-01-08',
        type: 'フルタイム',
        location: '中国湖州',
        experience: '1〜3年',
        salary: '¥12K-20K',
        description: '生産プロセスを最適化し、炭素材料製品の品質と効率を確保。',
        requirements: [
          '化学工学または関連分野の学士号',
          '化学生産経験1年以上',
          '品質管理と安全手順の知識',
          '強力な分析力と問題解決能力',
          '良好なチームワーク精神'
        ],
        responsibilities: [
          '炭素材料生産プロセスの監視と最適化',
          'プロセスパラメータの調整と設備のメンテナンスの実施',
          '品質管理手順を実行し、製品仕様を確保',
          '生産データを分析し、改善提案を行う',
          '新しいプロセスの開発と検証に参加'
        ],
        benefits: [
          '安定した給与収入',
          '完全な五険一金',
          'スキルアップ研修の機会',
          '仕事の安定性の保証',
          '良好な労働環境とチーム雰囲気'
        ]
      }
    },
    culture: {
      innovation: {
        title: 'イノベーション主導',
        description: '私たちは革新的な思考を奨励し、最先端の技術研究開発に投資し、あなたのアイデアがここで実を結ぶようにします。'
      },
      growth: {
        title: 'キャリア開発',
        description: '完全な研修システムと昇進ルートが、あなたのキャリア成長と個人的な発展を支援します。'
      },
      teamwork: {
        title: 'チームワーク',
        description: '多様な国際チーム、オープンで包括的な作業環境、卓越性の共同追求。'
      },
      benefits: {
        title: '福利厚生',
        description: '競争力のある報酬、完全な社会保障福利厚生、年次健康診断、チームビルディング活動などの豊富な福利厚生。'
      }
    }
  },
  contact: {
    title: 'お問い合わせ',
    titleCard: 'お問い合わせ',
    subtitle: '以下の方法でご連絡いただけます',
    contactInfo: '連絡先情報',
    phone: '電話',
    overseasOffice: '海外事務所',
    usOffice: '米国事務所',
    usAddress: 'アメリカ合衆国テキサス州ヒューストン',
    usAddressFull: '12603 Southwest Fwy, Suite 210, Stafford, Texas 77477, USA',
    mapLoadError: '地図の読み込みに失敗しました。後でもう一度お試しください',
    mapAlt: '会社所在地地図 - 中国浙江省湖州市南太湖新区西鳳路688号',
    companyName: '湖州欧美化学',
    phoneConsultation: '電話相談',
    phoneHours: '月曜日から金曜日 9:00-18:00',
    email: '電子メール',
    emailNote: '24時間以内に返信',
    address: '会社住所',
    addressNote: '中国浙江省湖州市南太湖新区',
    onlineSupport: 'オンラインカスタマーサービス',
    onlineSupportNote: 'クリックしてチャットを開始',
    supportHours: '営業日 9:00-22:00',
    messageConsultation: 'メッセージ相談',
    nameLabel: '* 氏名',
    namePlaceholder: '氏名を入力してください',
    phoneLabel: '電話番号',
    phonePlaceholder: '電話番号を入力してください',
    emailLabel: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力してください',
    companyLabel: '会社名',
    companyPlaceholder: '会社名を入力してください',
    messageLabel: 'メッセージ内容',
    messagePlaceholder: 'メッセージ内容を入力してください',
    submit: '送信',
    reset: 'リセット',
    companyLocation: '会社所在地',
    companyFullName: '湖州欧美化学有限公司',
    postalCode: '郵便番号',
    loadingMap: '地図読み込み中...',
    mapNote: '実際のプロジェクトでは、Baidu MapまたはAmap APIを統合できます',
    nameRequired: '氏名を入力してください',
    emailInvalid: '正しいメールアドレスを入力してください',
    submitSuccess: 'メッセージは正常に送信されました。できるだけ早くご連絡いたします',
    calling: '電話 0572-2678666 に発信しています',
    openingEmail: 'メールクライアントを開いています',
    onlineServiceDeveloping: 'オンラインカスタマーサービス機能は開発中です。電話またはメールでお問い合わせください',
    emailSubject: 'お問い合わせ',
    emailBody: 'こんにちは、詳細について知りたいです。'
  },
  language: {
    title: '言語選択',
    subtitle: 'お好みの言語を選択してください',
    description: '当社は、世界中のユーザーが当社のサービスを便利に利用できるように、多言語サポートを提供することに尽力しています。',
    contactNote: '他の言語サポートが必要な場合は、カスタマーサービスチームにお問い合わせください。',
    current: '現在の選択',
    switchSuccess: '言語が以下に切り替わりました:',
    chineseSimplified: '簡体字中国語',
    chineseTraditional: '繁体字中国語',
    english: 'English',
    spanish: 'Español',
    chineseSimplifiedDesc: '中国本土で使用される標準中国語',
    chineseTraditionalDesc: '台湾地域で使用される伝統的な中国語',
    englishDesc: '標準アメリカ英語',
    spanishDesc: '標準スペイン語'
  },
  shareModal: {
    title: 'ページを共有',
    selectPlatform: '共有プラットフォームを選択',
    copyLink: 'リンクをコピー',
    copy: 'コピー',
    copySuccess: 'リンクが正常にコピーされました！',
    wechatTip: 'WeChat共有機能は開発中です。リンクをコピーして手動で共有できます',
    shareToFacebook: 'Facebookで共有',
    shareToLinkedIn: 'LinkedInで共有'
  },
  languageWelcome: {
    title: 'はじめまして、言語を選択してください',
    subtitle: '多言語サポートを提供しています。お好みの言語を選択してください',
    note: '設定でいつでも言語設定を変更できます',
    switchSuccess: '言語が以下に切り替わりました:'
  },
  menuCarousel: {
    home: {
      title: 'ホーム',
      subtitle: '湖州欧美化学へようこそ',
      description: 'プロの化学製品メーカーとして、お客様に高品質な製品とサービスを提供します',
      viewMore: '詳細を見る'
    },
    about: {
      title: '会社概要',
      subtitle: 'エネルギーと環境に対する人類のニーズを革新的にバランス',
      description: '湖州欧美化学有限公司は、ハイテク製品の研究開発と生産に焦点を当て、業界のリーディングカンパニーになりました',
      viewMore: '詳細を見る'
    },
    solventFreeProducts: {
      title: '無溶剤粘合剤',
      subtitle: '環境に優しい無溶剤複合粘合剤',
      description: '高性能無溶剤複合粘合剤、食品包装など様々な用途に対応、環境に優しく安全で効率的な特徴を持ちます',
      viewMore: '製品を見る'
    },
    esterSolventProducts: {
      title: 'エステル溶剤粘合剤',
      subtitle: '高性能エステル溶剤複合粘合剤',
      description: '専門エステル溶剤複合粘合剤、優れた粘合性能を持ち、様々な包装材料に広く応用されています',
      viewMore: '製品を見る'
    },
    alcoholicSolventProducts: {
      title: 'アルコール溶剤粘合剤',
      subtitle: '高性能アルコール溶剤複合粘合剤',
      description: '専門アルコール溶剤複合粘合剤、優れた粘合性能を持ち、様々な包装材料に広く応用されています',
      viewMore: '製品を見る'
    },
    materials: {
      title: '新型炭素材料',
      subtitle: '先端炭素材料技術',
      description: '主にカーボンナノチューブとペースト、カーボンナノファイバー、多重グラファイトベースの陽極材料、水性粘合剤、N-メチルピロリドンが含まれます',
      viewMore: '詳細を見る'
    },
    news: {
      title: 'ニュースセンター',
      subtitle: '会社の最新動向を知る',
      description: '会社の最新情報と業界の動向を入手し、技術革新と市場拡大における最新の進捗状況を理解する',
      viewMore: 'ニュースを見る'
    },
    support: {
      title: '技術サポート',
      subtitle: '専門的な技術文書とサポート',
      description: '完全な技術データシート、製品仕様、使用ガイドなどの専門的な文書を提供し、お客様に包括的な技術サポートを提供します',
      viewMore: 'サポートを受ける'
    },
    hr: {
      title: '採用情報',
      subtitle: '私たちに参加して、より良い未来を創造しましょう',
      description: '私たちはあらゆる分野の優秀な人材をチームに招待し、競争力のある報酬と広範な発展の機会を提供します',
      viewMore: '職種を見る'
    },
    contact: {
      title: 'お問い合わせ',
      subtitle: 'いつでもご連絡ください',
      description: '私たちはあなたの協力をお待ちしており、様々な方法で専門的なコンサルティングとサービスサポートを提供します',
      viewMore: '連絡先情報'
    }
  },
  productsPage: {
    pageTitle: '粘合剤剤',
    title: '製品紹介',
    meta: {
      description: '湖州欧美化学有限公司 製品紹介 - 軟包装複合用粘合剤剤、エンジニアリング構造用粘合剤剤などのプロの化学製品'
    },
    solventFree: {
      title: '無溶剤粘合剤剤',
      subtitle: '無溶剤粘合剤剤'
    },
    esterSolvent: {
      title: 'エステル溶剤粘合剤剤',
      subtitle: 'エステル溶剤粘合剤剤'
    },
    performanceLevel: '性能レベル',
    icons: {
      lamination: {
        main: '積層',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '100°C/30分 煮沸 透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'レトルト',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: '耐薬品性',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance',
      standard: '経済型',
      standardSub: 'Cost Effective'
    }
  },
  solventFreeProductsPage: {
    pageTitle: '無溶剤粘合剤剤',
    title: '無溶剤粘合剤剤-製品紹介',
    meta: {
      description: '湖州欧美化学有限公司 製品紹介 - 軟包装複合用粘合剤剤、エンジニアリング構造用粘合剤剤などのプロの化学製品'
    },
    solventFree: {
      title: '無溶剤粘合剤剤',
      subtitle: '軟包装積層用の総合的な第一選択粘合剤'
    },
    performanceLevel: '性能レベル',
    icons: {
      lamination: {
        main: '積層',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '100°C/30分 煮沸 透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'レトルト',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance',
      standard: '経済型',
      standardSub: 'Cost Effective'
    },
    features :'とくせい'
  },
  esterSolventProductsPage: {
    pageTitle: 'エステル溶剤粘合剤',
    title: 'エステル溶剤粘合剤-製品紹介',
    meta: {
      description: '湖州欧美化学有限公司 製品紹介 - 軟包装複合用粘合剤剤、エンジニアリング構造用粘合剤剤などのプロの化学製品'
    },
    esterSolvent: {
      title: 'エステル溶剤粘合剤剤',
      subtitle: '軟包装積層用の総合的な第一選択粘合剤'
    },
    performanceLevel: '性能レベル',
    icons: {
      lamination: {
        main: '積層',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '100°C/30分 煮沸 透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'レトルト',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: '耐薬品性',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance',
      standard: '経済型',
      standardSub: 'Cost Effective'
    },
    features :'とくせい'
  },
  alcoholicSolventProductsPage: {
    pageTitle: 'アルコール溶剤粘合剤',
    title: 'アルコール溶剤粘合剤-製品紹介',
    meta: {
      description: '湖州欧美化学有限公司 製品紹介 - 軟包装複合用粘合剤剤、エンジニアリング構造用粘合剤剤などのプロの化学製品'
    },
    alcoholicSolvent: {
      title: 'アルコール溶剤粘合剤剤',
      subtitle: '軟包装積層用の総合的な第一選択粘合剤'
    },
    performanceLevel: '性能レベル',
    icons: {
      lamination: {
        main: '積層',
        sub: 'LAMINATION'
      },
      boiling: {
        main: '100°C/30分 煮沸 透明',
        sub: 'BOILING PASTEURIZATION'
      },
      retort: {
        main: 'レトルト',
        sub: 'RETORT'
      },
      specialities: {
        main: '特殊性能',
        sub: 'SPECIALITIES'
      },
      chemical: {
        main: '耐薬品性',
        sub: 'CHEMICAL RESISTANCE'
      }
    },
    performance: {
      high: '高性能',
      highSub: 'High Performance',
      medium: '中性能',
      mediumSub: 'Medium Performance',
      standard: '経済型',
      standardSub: 'Cost Effective'
    },
    features :'とくせい'

  },
  companyName: "湖州オケム化学有限公司"
}